import React from 'react'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'
import withStyles from '@material-ui/core/styles/withStyles'
import {fade} from '@material-ui/core/styles/colorManipulator'
import HeaderItem from './HeaderItem'
import HeaderUserItem from './HeaderUserItem'
import Colors from '../../../shared/assets/styles/colors'
import logo from './../../../shared/assets/img/logo-black.svg'
import {Link} from 'react-router-dom'
import PageData from '../../../shared/utils/PageData'
// import LanguageSelector from '../LanguageSelector/LanguageSelector'

const styles = ({palette, spacing: {unit}}) => ({
  root: {
    height: 64,
    paddingLeft: 0,
    backgroundColor: Colors.White,
    color: Colors.Black,
    display: 'flex',
    boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.2)',
    justifyContent: 'space-between',
    zIndex: 2
  },
  logo: {
    marginTop: unit * 0.25,
    marginLeft: unit * 5,
    position: 'relative',
    alignSelf: 'flex-start',
    display: 'flex',
    flexDirection: 'row'
  },
  platformName: {
    flip: false,
    fontSize: '0.977em',
    color: Colors.Black,
    alignSelf: 'flex-end',
    bottom: 0
  },
  items: {
    display: 'flex',
    alignItems: 'center',
    '& > *+*': {
      marginLeft: unit
    }
  },
  versionChip: {
    backgroundColor: fade(Colors.Black, 0.1),
    color: Colors.Black,
    // marginLeft: unit,
    '&:hover': {
      color: palette.primary.main
    }
  }
})

class Header extends React.Component {
  state = {
    scrolled: false,
    showLogoutDialog: false
  }

  _handleItemClick = (itemData, props) => {
    if (props && props.api && typeof this.props.api[props.api] === 'function') {
      return this.props.api[props.api]()
    }
  }

  render() {
    const {
      classes,
      member,
      data: {items = []}
    } = this.props

    let {settings: {general: {platformName} = {}} = {}, version} =
      PageData.appFrame || {}
    platformName = platformName || ''

    return (
      <Toolbar className={classes.root}>
        <Link
          to={'/'}
          className={classes.logo}
          style={{flip: false, direction: 'ltr'}}
        >
          <img src={logo} alt="" />
          <Typography
            className={classes.platformName}
            variant={'caption'}
            color={'primary'}
          >
            {platformName.toUpperCase()}
          </Typography>
        </Link>

        <div className={classes.items}>
          {/* <LanguageSelector /> */}

          {items.map(({component, props, data}, index) => {
            const Component = components[component]
            return (
              <Component
                key={'item_' + index}
                {...props}
                member={member}
                className={classes.item}
                onClick={() => this._handleItemClick(data, props)}
              />
            )
          })}
          <Chip
            label={`v${version}`}
            className={classes.versionChip}
            onClick={() => {}}
            clickable
            component={Link}
            to={'/version'}
          />
        </div>
      </Toolbar>
    )
  }
}

const components = {
  HeaderItem,
  HeaderUserItem
}

export default withStyles(styles)(Header)



// WEBPACK FOOTER //
// ./src/components/molecules/Header/Header.js